import React from 'react'
import { connect } from 'react-redux'
import {
  Button,
  FormGroup
} from 'reactstrap'
import PropTypes from 'prop-types'

import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import confirmationActions from './actions'
import DeviseLayout from '../DeviseLayout'
import EmailField from '../../components/EmailField'
import PageLoader from '../../components/PageLoader'

class DeviseConfirmationsNew extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: ''
    }

    const { dispatch } = this.props
    dispatch(confirmationActions.reset())
  }

  handleEmailChange({ target: { value } }) {
    this.setState({
      email: value
    })
  }

  handleSubmit(event) {
    const { email } = this.state
    const { dispatch } = this.props

    event.preventDefault()

    if (email === '') {
      this.emailField.showAsInvalid()
    } else {
      dispatch(confirmationActions.resendConfirmation({ email }))
    }
  }

  render() {
    const {
      resendingError,
      resendingStatus,
      t
    } = this.props

    return (
      <DeviseLayout
        onSubmit={(event) => this.handleSubmit(event)}
        title={t('DeviseConfirmationsNew.title', { ns: 'devise' })}
      >
        <EmailField
          inputId="email"
          inputName="email"
          onChange={(event) => this.handleEmailChange(event)}
          ref={(element) => { this.emailField = element }}
        />
        <FormGroup>
          <div className="d-flex flex-column">
            {resendingStatus === 'resending' && (
              <PageLoader
                message={t('DeviseConfirmationsNew.resending', { ns: 'devise' })}
              />
            )}
            {resendingStatus === 'failed' && (
              <AlertMessage>
                {resendingError || t('errors.somethingWentWrong', { ns: 'commons' })}
              </AlertMessage>
            )}
            {resendingStatus === 'succeeded' && (
              <AlertMessage color="success">
                {resendingError
                  || t('DeviseConfirmationsNew.confirmation_resend_suceeded', { ns: 'devise' })}
              </AlertMessage>
            )}
            <Button
              className="mb-3"
              color="primary"
            >
              {t('buttons.resend_confirmation_email', { ns: 'commons' })}
            </Button>
          </div>
        </FormGroup>
      </DeviseLayout>
    )
  }
}

DeviseConfirmationsNew.propTypes = {
  resendingError: PropTypes.string,
  resendingStatus: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
}

DeviseConfirmationsNew.defaultProps = {
  resendingError: null
}

const mapStateToProps = ({
  resendConfirmation: {
    resendingError,
    resendingStatus
  }
}) => ({
  resendingError,
  resendingStatus
})

export default withTranslation(['devise', 'commons'])(
  connect(mapStateToProps)(DeviseConfirmationsNew)
)
